export const TabVectorLeft = ({ className }) => (
  <svg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
    <path fillRule='evenodd' clipRule='evenodd' d='M0 10C0 10 10 10 10 0V6.12245V10H0Z' />
  </svg>
)
